export default __webpack_public_path__ + "media/zurb/img/ecommerce/shopping_flow4-e983b1708dd257e31ea3ecc65080cb24.png";